import Client from "./Client";
// import RequestList from "./RequestList";

const LogsService = {
    url: 'admin/logs',
    getDefault(){
        return {

        }
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList.json());
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async getById(logId) {
        return await Client.get(`${this.url}/${logId}`);
    }
}

export default LogsService